// src/components/MapSatelliteModal.js
import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, CircularProgress, Typography } from '@mui/material';
import { LoadScript, GoogleMap, Marker } from '@react-google-maps/api';

const containerStyle = {
  width: '100%',
  height: '400px'
};

const MapSatelliteModal = ({ open, handleClose, address }) => {
  const [coords, setCoords] = useState(null);
  const [loading, setLoading] = useState(false);
  const [googleLoaded, setGoogleLoaded] = useState(false);

  // Géocodification de l'adresse lorsque le modal est ouvert et l'API est chargée
  useEffect(() => {
    if (open && address && googleLoaded) {
      setLoading(true);
      const geocoder = new window.google.maps.Geocoder();
      // On peut ajuster l'adresse si besoin (ex : ajouter ", Espagne")
      const fullAddress = address.includes('Espagne') ? address : `${address}, Espagne`;
      console.log("Adresse envoyée à geocode:", fullAddress);
      geocoder.geocode({ address: fullAddress }, (results, status) => {
        console.log("Résultats du géocodage:", results, "Status:", status);
        if (status === 'OK' && results[0]) {
          const location = results[0].geometry.location;
          setCoords({ lat: location.lat(), lng: location.lng() });
        } else {
          console.error("Erreur de géocodage:", status);
          setCoords(null);
        }
        setLoading(false);
      });
    }
  }, [open, address, googleLoaded]);

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle>Vue Satellite pour : {address}</DialogTitle>
      <DialogContent>
        <LoadScript
          googleMapsApiKey="AIzaSyBDxjT-tqx2etydNtgDJP6oLQkdKcZ3EaY"
          onLoad={() => {
            console.log("Google Maps API chargée");
            setGoogleLoaded(true);
          }}
        >
          {loading && <CircularProgress />}
          {!loading && coords && (
            <GoogleMap
              mapContainerStyle={containerStyle}
              center={coords}
              zoom={18}
              options={{
                mapTypeId: 'satellite',
                streetViewControl: true, // Laisser l'utilisateur activer Street View manuellement
              }}
            >
              <Marker position={coords} />
            </GoogleMap>
          )}
          {!loading && !coords && (
            <Typography color="error">Adresse introuvable.</Typography>
          )}
        </LoadScript>
      </DialogContent>
    </Dialog>
  );
};

export default MapSatelliteModal;
